<script setup lang="ts">
import { computed, onMounted } from 'vue';

const props = defineProps({
  contentType: {
    type: String,
    required: true,
  },
  display: {
    type: Boolean,
    default: false,
  },
  triggerLoadOnMount: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits<{
  loadOnMount: [];
}>();

onMounted(() => {
  if (props.triggerLoadOnMount) {
    emits('loadOnMount');
  }
});

const iconClass = computed(() => {
  switch (props.contentType) {
    case 'zdjęcie':
    case 'zdjecie':
      return 'pi pi-photo';
    case 'wideo':
      return 'pi pi-video';
    case 'audio':
      return 'pi pi-play';
    case 'pdf':
      return 'pi pi-file-pdf';
    case 'zip':
      return 'pi pi-folder';
    case 'tekst':
      return 'pi pi-file-edit';
    case 'nieznany':
    default:
      return 'pi pi-file';
  }
});
</script>
<template>
  <span
    v-if="!props.display"
    class="preview-pictogram"
  >
    <i :class="iconClass" />
  </span>
</template>

<style scoped lang="scss">
.preview-pictogram {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: inherit;

  i {
    font-size: 4rem;
  }
}
</style>
